import Class from '@/utils/class'
import EventGenerator from '@/utils/eventGenerator'
import Socket from '@/utils/websocket'

export default Class.extend('tangoSocket', EventGenerator, {
  construct () {
    this.__socket = null
    this.__connectionPromise = null
  },

  __connect (name, endpoint) {
    return new Promise((resolve, reject) => {
      this.__disconnect()
      this.__socket = new Socket()
      this.__socket.addListener('connected', this.__onConnect, this)
      this.__socket.addListener('closed', this.__onClose, this)
      this.__socket.addListener('message', this.onMessage, this)
      this.__connectionPromise = {resolve: resolve, reject: reject}
      this.__socket.connect(name, endpoint)
    })
  },

  __disconnect () {
    if (this.__connectionPromise !== null) {
      this.__connectionPromise.reject(new Error('Connection cancelled'))
      this.__connectionPromise = null
    }
    if (this.__socket !== null) {
      this.__socket.close()
      this.__socket.removeListener('connected', this.onConnect, this)
      this.__socket.removeListener('closed', this.onClose, this)
      this.__socket.removeListener('message', this.onMessage, this)
      this.__socket = null
    }
  },

  __isConnected () {
    return this.__connectionPromise !== null || (this.__socket && this.__socket.connected())
  },

  getConnection () {
    return new Promise((resolve, reject) => {
      if (this.__connectionPromise !== null) {
        let timer = setInterval(() => {
          if (this.__connectionPromise === null) {
            clearInterval(timer)
            if (this.__socket !== null) {
              resolve()
            } else {
              reject(new Error('Connection failed'))
            }
          }
        }, 100)
      }
      else if (this.__socket !== null) {
        resolve()
      } else {
        reject()
      }
    })
  },

  __onConnect () {
    if (this.__connectionPromise !== null) {
      this.__connectionPromise.resolve()
      this.__connectionPromise = null
    }
    this.onConnect()
  },

  __onClose () {
    if (this.__connectionPromise !== null) {
      this.__connectionPromise.reject(new Error('Connection failed'))
      this.__connectionPromise = null
    }
    this.onClose()
  },

  close () {
    this.__disconnect()
  },

  request (data) {
    return this.__socket.request(data)
  },

  send (data) {
    this.__socket.send(data)
  },

  onConnect () {},
  onClose () {},
  onMessage () {}

})
